module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_42.8a9fb724.png";